import { EnvironmentCommonModel } from '../app/model/environment-common/environment-common.model';
import { environment } from './environment';

export const environmentCommon: EnvironmentCommonModel = {
  company: {
    website: 'https://codigrate.com',
    email: 'info@codigrate.com',
    social: {
      twitter: 'codigrate',
      linkedin: 'codigrate',
      github: 'codigrate',
      youtube: '@codigrate',
      instagram: 'codigrate_',
      pinterest: 'codigrate',
      medium: '@codigrate',
      googleDeveloper: '111622050057560112042'
    }
  },

  website: {
    // oauth
    google: {
      name: 'Google',
      logo: './assets/third-parties/logo/google.webp',
      cssClass: 'google',
      url: 'https://google.com',
      callbackParams: [ 'code', 'state' ],
      tag: environment.oauth.google.tag,
      websiteType: 'oauth'
    },
    linkedin: {
      name: 'LinkedIn',
      logo: './assets/third-parties/logo/linkedin.webp',
      cssClass: 'linkedin-in',
      url: 'https://www.linkedin.com',
      companyUrl: 'https://www.linkedin.com/company',
      shareUrl: 'https://www.linkedin.com/sharing/share-offsite/?url=',
      callbackParams: [ 'code', 'state' ],
      tag: environment.oauth.linkedin.tag,
      websiteType: 'oauth'
    },
    github: {
      name: 'GitHub',
      logo: './assets/third-parties/logo/github.webp',
      cssClass: 'github',
      url: 'https://github.com',
      callbackParams: [ 'code', 'state' ],
      tag: environment.oauth.github.tag,
      api: {
        repo: 'https://api.github.com/repos'
      },
      websiteType: 'oauth'
    },
    facebook: {
      name: 'Facebook',
      logo: './assets/third-parties/logo/facebook.webp',
      cssClass: 'facebook-f',
      url: 'https://facebook.com',
      callbackParams: [ 'code' ],
      tag: environment.oauth.facebook.tag,
      websiteType: 'oauth'
    },
    twitter: {
      name: 'Twitter',
      logo: './assets/third-parties/logo/twitter.webp',
      cssClass: 'twitter',
      url: 'https://twitter.com',
      shareUrl: 'https://twitter.com/intent/tweet?url=',
      callbackParams: [ 'oauth_token', 'oauth_verifier' ],
      tag: environment.oauth.twitter.tag,
      websiteType: 'oauth',
    },
    twitch: {
      name: 'Twitch',
      logo: './assets/third-parties/logo/twitch.webp',
      cssClass: 'twitch',
      callbackParams: [ 'code', 'state' ],
      tag: environment.oauth.twitch.tag,
      websiteType: 'oauth'
    },
    dribbble: {
      name: 'Dribbble',
      logo: './assets/third-parties/logo/dribbble.webp',
      cssClass: 'dribbble',
      callbackParams: [ 'code', 'state' ],
      tag: environment.oauth.dribbble.tag,
      websiteType: 'oauth'
    },
    reddit: {
      name: 'Reddit',
      logo: './assets/third-parties/logo/reddit.webp',
      cssClass: 'reddit',
      callbackParams: [ 'code', 'state' ],
      tag: environment.oauth.reddit.tag,
      websiteType: 'oauth'
    },

    // payment
    stripe: {
      name: 'Stripe',
      logo: './assets/third-parties/logo/stripe.webp',
      cssClass: 'stripe-s',
      tag: environment.payment.stripe.tag,
      publishableKey: environment.payment.stripe.publishableKey,
      websiteType: 'payment'
    },
    paypal: {
      name: 'PayPal',
      logo: './assets/third-parties/logo/paypal.webp',
      cssClass: 'paypal',
      version: '5.0.128',
      tag: environment.payment.paypal.tag,
      clientId: environment.payment.paypal.clientId,
      env: environment.payment.paypal.env,
      websiteType: 'payment'
    },

    // file storage
    aws: {
      name: 'Aws',
      logo: './assets/third-parties/logo/aws.webp',
      cssClass: 'aws',
      url: 'https://aws.amazon.com',
      tag: environment.fileStorage.aws.tag,
      websiteType: 'file-storage'
    },
    googleCloud: {
      name: 'Google Cloud',
      logo: './assets/third-parties/logo/google-cloud.webp',
      cssClass: 'google-cloud',
      url: 'https://cloud.google.com/storage',
      tag: environment.fileStorage.googleCloud.tag,
      websiteType: 'file-storage'
    },

    // mail
    gmail: {
      name: 'Gmail',
      logo: './assets/third-parties/logo/gmail.webp',
      cssClass: 'gmail',
      url: 'https://gmail.com',
      tag: environment.mail.gmail.tag,
      websiteType: 'mail'
    },
    yahoo: {
      name: 'Yahoo',
      logo: './assets/third-parties/logo/yahoo.webp',
      cssClass: 'yahoo',
      url: 'https://yahoo.com',
      tag: environment.mail.yahoo.tag,
      websiteType: 'mail'
    },
    outlook: {
      name: 'Outlook',
      logo: './assets/third-parties/logo/outlook.webp',
      cssClass: 'outlook',
      url: 'https://outlook.com',
      tag: environment.mail.outlook.tag,
      websiteType: 'mail'
    },

    // sms
    twillio: {
      name: 'Twillio',
      logo: './assets/third-parties/logo/twilio.webp',
      cssClass: 'twillio',
      url: 'https://www.twilio.com',
      tag: environment.sms.twillio.tag,
      websiteType: 'sms'
    },
    awsSns: {
      name: 'Aws Sns',
      logo: './assets/third-parties/logo/aws-sns.webp',
      cssClass: 'aws',
      url: 'https://aws.amazon.com',
      tag: environment.sms.awsSns.tag,
      websiteType: 'sms'
    },

    // analytics
    googleAnalytics: {
      name: 'Google Analytics',
      logo: './assets/third-parties/logo/google-analytics.webp',
      cssClass: 'google',
      url: 'https://analytics.google.com',
      tag: environment.analytics.googleAnalytics.tag,
      websiteType: 'analytics'
    },
    matomo: {
      name: 'Matomo',
      logo: './assets/third-parties/logo/matomo.webp',
      cssClass: 'matomo',
      url: 'https://matomo.org',
      tag: environment.analytics.matomo.tag,
      websiteType: 'analytics'
    },
    mixPanel: {
      name: 'Mixpanel',
      logo: './assets/ext/open-template-hub/assets/third-parties/logo/mixpanel.webp',
      cssClass: 'mixpanel',
      url: 'https://mixpanel.com',
      tag: environment.analytics.mixPanel.tag,
      websiteType: 'analytics'
    },

    // other
    instagram: {
      name: 'Instagram',
      cssClass: 'instagram',
      url: 'https://instagram.com',
      websiteType: 'other'
    },
    youtube: {
      name: 'YouTube',
      cssClass: 'youtube',
      url: 'https://youtube.com',
      websiteType: 'other'
    },
    productHunt: {
      name: 'Product Hunt',
      cssClass: 'product-lines-hunt',
      url: 'https://www.producthunt.com',
      websiteType: 'other'
    },
    appleCalendar: {
      name: 'Apple Calendar',
      logo: './assets/third-parties/logo/apple-calendar.webp',
      cssClass: 'apple-calendar',
      websiteType: 'other'
    },
    googleCalendar: {
      name: 'Google Calendar',
      logo: './assets/third-parties/logo/google-calendar.webp',
      cssClass: 'google-calendar',
      websiteType: 'other'
    },
    discord: {
      name: 'Discord',
      logo: './assets/third-parties/logo/discord.webp',
      cssClass: 'discord',
      websiteType: 'other',
      companyUrl: 'https://discord.gg'
    },
    npm: {
      name: 'Npm',
      cssClass: 'npm',
      url: 'https://www.npmjs.com',
      api: {
        download: 'https://api.npmjs.org/downloads/point'
      },
      websiteType: 'other'
    },
    pinterest: {
      name: 'Pinterest',
      cssClass: 'pinterest',
      url: 'https://pinterest.com',
      websiteType: 'other'
    },
    medium: {
      name: 'Medium',
      logo: './assets/third-parties/logo/medium.webp',
      cssClass: 'medium',
      url: 'https://medium.com',
      websiteType: 'other'
    },
    jetbrainsMarketplace: {
      name: 'JetBrains',
      logo: './assets/third-parties/logo/jetbrains.webp',
      cssClass: 'jetbrains',
      category: 'IDE',
      url: 'https://plugins.jetbrains.com',
      api: {
        download: 'https://plugins.jetbrains.com/api/plugins'
      },
      websiteType: 'other'
    },
    googleDeveloper: {
      name: 'Google Developer Program',
      logo: './assets/third-parties/logo/google.webp',
      cssClass: 'google',
      url: 'https://developers.google.com/profile/u',
      websiteType: 'other'
    },
    chrome: {
      name: 'Chrome',
      logo: './assets/third-parties/logo/chrome.webp',
      cssClass: 'google',
      category: 'Browser',
      url: 'https://www.google.com/chrome',
      websiteType: 'other'
    },
    firefox: {
      name: 'Firefox',
      logo: './assets/third-parties/logo/firefox.webp',
      cssClass: 'firefox',
      category: 'Browser',
      url: 'https://www.mozilla.org/firefox',
      websiteType: 'other'
    },
    openVsx: {
      name: 'Open VSX',
      logo: './assets/third-parties/logo/open-vsx.webp',
      cssClass: 'open-vsx',
      category: 'IDE',
      url: 'https://open-vsx.org',
      supportedPlatforms: [
        {
          name: 'Cursor',
          logo: './assets/third-parties/logo/cursor.webp',
          cssClass: 'cursor',
          url: 'https://cursor.sh',
          websiteType: 'other'
        },
        {
          name: 'Antigravity',
          logo: './assets/third-parties/logo/antigravity.webp',
          cssClass: 'antigravity',
          url: 'https://antigravity.sh',
          websiteType: 'other'
        },
        {
          name: 'VS Codium',
          logo: './assets/third-parties/logo/vscodium.webp',
          cssClass: 'vscodium',
          url: 'https://vscodium.com',
          websiteType: 'other'
        },
      ],
      websiteType: 'other'
    },
    slack: {
      name: 'Slack',
      logo: './assets/third-parties/logo/slack.webp',
      cssClass: 'slack',
      category: 'Communication',
      url: 'https://slack.com',
      downloadable: true,
      websiteType: 'other'
    },
    macos: {
      name: 'MacOS Terminal',
      logo: './assets/third-parties/logo/macos.webp',
      cssClass: 'macos',
      category: 'Terminal',
      url: 'https://support.apple.com/guide/terminal/welcome/mac',
      downloadable: true,
      websiteType: 'other'
    },
    ghostty: {
      name: 'Ghostty',
      logo: './assets/third-parties/logo/ghostty.webp',
      cssClass: 'ghostty',
      category: 'Terminal',
      url: 'https://ghostty.org',
      downloadable: true,
      websiteType: 'other'
    },
    claudeCode: {
      name: 'Claude Code',
      logo: './assets/third-parties/logo/claude-code.webp',
      cssClass: 'claude-code',
      category: 'Terminal',
      url: 'https://www.anthropic.com/claude-code',
      downloadable: true,
      websiteType: 'other'
    },
    opencode: {
      name: 'OpenCode',
      logo: './assets/third-parties/logo/opencode.webp',
      cssClass: 'opencode',
      category: 'Terminal',
      url: 'https://opencode.ai',
      downloadable: true,
      websiteType: 'other'
    },
    codex: {
      name: 'Codex',
      logo: './assets/third-parties/logo/codex.webp',
      cssClass: 'codex',
      category: 'Terminal',
      url: 'https://developers.openai.com/codex/cli',
      downloadable: true,
      websiteType: 'other'
    },
    iterm2: {
      name: 'iTerm2',
      logo: './assets/third-parties/logo/iterm2.webp',
      cssClass: 'iterm2',
      category: 'Terminal',
      url: 'https://iterm2.com',
      downloadable: true,
      websiteType: 'other'
    },
    rhino: {
      name: 'Rhino',
      logo: './assets/third-parties/logo/rhino.webp',
      cssClass: 'rhino',
      category: 'CAD',
      url: 'https://www.rhino3d.com',
      downloadable: true,
      contentPage: true,
      websiteType: 'other'
    },
    xcode: {
      name: 'Xcode',
      logo: './assets/third-parties/logo/xcode.webp',
      cssClass: 'xcode',
      category: 'IDE',
      url: 'https://developer.apple.com/xcode/',
      downloadable: true,
      websiteType: 'other'
    },
    zed: {
      name: 'Zed',
      logo: './assets/third-parties/logo/zed.webp',
      cssClass: 'zed',
      category: 'Text Editor',
      url: 'https://zed.dev',
      downloadable: true,
      websiteType: 'other'
    },
    sublimeText: {
      name: 'Sublime Text',
      logo: './assets/third-parties/logo/sublime.webp',
      cssClass: 'sublime',
      category: 'Text Editor',
      url: 'https://www.sublimetext.com',
      downloadable: true,
      websiteType: 'other'
    },
    vscode: {
      name: 'VS Code',
      logo: './assets/third-parties/logo/vscode.webp',
      cssClass: 'vscode',
      category: 'IDE',
      url: 'https://code.visualstudio.com',
      websiteType: 'other'
    },
    line: {
      name: 'Line',
      logo: './assets/third-parties/logo/line.webp',
      cssClass: 'line',
      category: 'Communication',
      url: 'https://store.line.me',
      contentPage: true,
      websiteType: 'other'
    },
  },
};
